exports.components = {
  "component---src-pages-account-tsx": () => import("./../../../src/pages/account.tsx" /* webpackChunkName: "component---src-pages-account-tsx" */),
  "component---src-pages-airdrop-tsx": () => import("./../../../src/pages/airdrop.tsx" /* webpackChunkName: "component---src-pages-airdrop-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-invite-tsx": () => import("./../../../src/pages/invite.tsx" /* webpackChunkName: "component---src-pages-invite-tsx" */),
  "component---src-pages-leaderboard-tsx": () => import("./../../../src/pages/leaderboard.tsx" /* webpackChunkName: "component---src-pages-leaderboard-tsx" */)
}

